import React from 'react';
import { IconLibrary } from '../../../interfaces/icon/IconLibrary';
import Icon from '../icons/Icon';


const CloseButton = ({ ariaLabel, onButtonClick}: {ariaLabel: string, onButtonClick: ()=>void}) => {
    return (
        <button
            className='close-button'
            aria-label={ariaLabel}
            onClick={onButtonClick}
            type={'button'}
        >
            <Icon iconName={IconLibrary.CLOSE}  sizeInPx='10' color='var(--thriveLightSlate)'/>
        </button>
    );
};

export default CloseButton